import React from 'react';
import useImage from 'use-image';

import { toTzMoment } from '../../../shared/lib';
import { lightTheme } from './theme';

const { color } = lightTheme.theme;
const { badge } = lightTheme.components;

export const URI = '/reserves-schemas';
export const SOON_MINUTES = 30;

export const getReservePersonName = (reserve: {
  firstName: string | null;
  lastName: string | null;
}): string => {
  return `${reserve.firstName || ''} ${reserve.lastName || ''}`.trim();
};

const warningTimeBar = {
  // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
  border: 'rgb(205, 189, 111)',
  bg: '#FDE272',
};

export const tableColors: GM.ReservesSchemas.TableStateColors = {
  FREE: {
    head: {
      border: '#000000',
      bg: '#181F28',
      color: '#FFFFFF',
    },
    frame: {
      // border: '#4C6893',
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      border: 'rgb(206, 214, 225)',
      bg: '#FFFFFF',
    },
    number: {
      color: '#181F28',
      dot: '#EA2727',
    },
    timeBar: {
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      border: 'rgb(145, 156, 174)',
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      bg: 'rgb(172, 177, 187)',
    },
  },
  OCCUPIED: {
    head: {
      border: '#1CBD91',
      bg: '#1CBD91',
      color: '#FFFFFF',
      stripe: 'rgba(0, 0, 0, 0.3)',
    },
    frame: {
      // border: '#4C6893',
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      border: 'rgb(206, 214, 225)',
      bg: '#FFFFFF',
    },
    number: {
      color: '#181F28',
      dot: '#EA2727',
    },
    timeBar: warningTimeBar,
  },
  OPEN: {
    head: {
      border: '#1CBD91',
      bg: '#1CBD91',
      color: '#FFFFFF',
    },
    frame: {
      // border: '#4C6893',
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      border: 'rgb(206, 214, 225)',
      bg: '#FFFFFF',
    },
    number: {
      color: '#181F28',
      dot: '#EA2727',
    },
    timeBar: warningTimeBar,
  },
  WARNING: {
    head: {
      border: '#EAAA08',
      bg: '#EAAA08',
      color: '#FFFFFF',
    },
    frame: {
      // border: '#4C6893',
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      border: 'rgb(206, 214, 225)',
      bg: '#FFFFFF',
    },
    number: {
      color: '#181F28',
      dot: '#EA2727',
    },
    timeBar: warningTimeBar,
  },
  DANGER: {
    head: {
      border: '#EA2727',
      bg: '#EA2727',
      color: '#FFFFFF',
    },
    frame: {
      // border: '#4C6893',
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      border: 'rgb(206, 214, 225)',
      bg: '#FFFFFF',
    },
    number: {
      color: '#181F28',
      dot: '#EA2727',
    },
    timeBar: warningTimeBar,
  },
  CONFLICT: {
    head: {
      border: '#C62828',
      bg: '#C62828',
      color: '#FFFFFF',
    },
    frame: {
      // TODO Не смог вытащить цвет рамки из Figma, нужно уточнить. Взял пипеткой
      border: 'rgb(188, 48, 57)',
      bg: '#EA2727',
    },
    number: {
      color: '#FFFFFF',
      dot: '#000000',
    },
  },
};

// TODO Не должна ли переменная быть в camelCase (тут и ниже)?
const FreeTableColors: GM.ReservesSchemas.SchemaTableColorSet = {
  bg: color.neutral[0],
  border: color.neutral[200],
  tableNumberColor: badge.secondary.neutral.label,
  tableNumberBg: badge.secondary.neutral.bg,
};

const ArrivedTableColors: GM.ReservesSchemas.SchemaTableColorSet = {
  bg: color.info[50],
  border: color.info[200],
  tableNumberColor: badge.secondary.info.label,
  tableNumberBg: badge.secondary.info.bg,
};

const OpenTableColors: GM.ReservesSchemas.SchemaTableColorSet = {
  bg: color.neutral[100],
  border: color.neutral[200],
  tableNumberColor: badge.secondary.neutral.label,
  tableNumberBg: badge.secondary.neutral.bg,
};

const SoonTableColors: GM.ReservesSchemas.SchemaTableColorSet = {
  bg: color.warning[100],
  border: color.warning[300],
  tableNumberColor: badge.secondary.warning.label,
  tableNumberBg: badge.secondary.warning.bg,
};

const DueTableColors: GM.ReservesSchemas.SchemaTableColorSet = {
  bg: color.error[50],
  border: color.error[200],
  tableNumberColor: badge.secondary.error.label,
  tableNumberBg: badge.secondary.error.bg,
};

export const TableStatusColors: GM.ReservesSchemas.TableStatusColors = {
  FREE: FreeTableColors,
  OPEN: {
    ...OpenTableColors,
    SOON: SoonTableColors,
    DUE: DueTableColors,
  },
  PRE_CHECK: {
    ...OpenTableColors,
    SOON: SoonTableColors,
    DUE: DueTableColors,
  },
  ARRIVED: {
    ...ArrivedTableColors,
    ARRIVED: ArrivedTableColors,
    SOON: SoonTableColors,
    DUE: DueTableColors,
  },
};

// @deprecated
export const TimeStatusColors: GM.ReservesSchemas.TimeStatusColors = {
  FREE: {
    color: FreeTableColors.tableNumberColor,
    bg: FreeTableColors.tableNumberBg,
  },
  ARRIVED: {
    color: ArrivedTableColors.tableNumberColor,
    bg: ArrivedTableColors.tableNumberBg,
  },
  OPEN: {
    color: OpenTableColors.tableNumberColor,
    bg: OpenTableColors.tableNumberBg,
  },
  SOON: {
    color: SoonTableColors.tableNumberColor,
    bg: SoonTableColors.tableNumberBg,
  },
  DUE: {
    color: DueTableColors.tableNumberColor,
    bg: DueTableColors.tableNumberBg,
  },
};

// @deprecated Это устаревшая функция, использовать getReserveItemState
export const getReserveItemTimeStatus = (
  reserve: GM.ReservesSchemas.ScheduleReserve | GM.ReservesSchemas.ScheduleOrder,
  restaurantTz: string,
): {
  status: GM.ReservesSchemas.TimeStatus;
  time: string;
} => {
  const reserveDate = toTzMoment(reserve.date, restaurantTz);
  const timeStr = reserveDate.format('HH:mm');
  const now = toTzMoment(undefined, restaurantTz);

  if (reserve.state === 'ARRIVED') {
    return { status: 'ARRIVED', time: timeStr };
  }

  if (isTableOccupied(reserve)) {
    return { status: 'OPEN', time: timeStr };
  }

  if (now.isAfter(reserveDate)) {
    return { status: 'DUE', time: timeStr };
  }

  if (reserveDate.diff(now, 'minutes') <= SOON_MINUTES) {
    return { status: 'SOON', time: timeStr };
  }

  return { status: 'FREE', time: timeStr };
};

export const getReserveItemState = (
  item: GM.ReservesSchemas.ScheduleReserve | GM.ReservesSchemas.ScheduleOrder,
  tableSchedule: GM.ReservesSchemas.TableSchedule,
  restaurantTz: string,
): GM.ReservesSchemas.TableStateV2 => {
  const date = toTzMoment(item.date, restaurantTz);
  const now = toTzMoment(undefined, restaurantTz);

  if (tableSchedule.current?.id === item.id) {
    // Состояние для стола
    const nextTime = tableSchedule.next
      ? toTzMoment(tableSchedule.next.date, restaurantTz)
      : undefined;

    const diffMinutes = nextTime && nextTime.diff(now, 'minutes');

    if (nextTime && now.isAfter(nextTime)) {
      return 'CONFLICT';
    } else if (
      diffMinutes &&
      diffMinutes > 0 &&
      diffMinutes <= SOON_MINUTES &&
      isTableOccupied(item)
    ) {
      return 'WARNING';
    } else if (isTableOpen(item)) {
      return 'OPEN';
    } else if (isTableOccupied(item)) {
      return 'OCCUPIED';
    } else if (now.isAfter(date)) {
      return 'DANGER';
    }
  } else {
    // Состояние для резерва
    const diffMinutes = date.diff(now, 'minutes');

    if (now.isAfter(date) && tableSchedule.current && tableSchedule.current.id !== item.id) {
      // Если время резерва наступило, а стол занят другим резервом, то это конфликт
      return 'CONFLICT';
    } else if (
      diffMinutes &&
      diffMinutes > 0 &&
      diffMinutes <= SOON_MINUTES &&
      tableSchedule.current &&
      tableSchedule.current.id !== item.id
    ) {
      return 'WARNING';
    } else if (isTableOpen(item)) {
      return 'OPEN';
    } else if (isTableOccupied(item)) {
      return 'OCCUPIED';
    } else if (now.isAfter(date)) {
      return 'DANGER';
    }
  }

  return 'FREE';
};

const isOccupiedState = (state: GM.Booking.BookingDTO['state']) => {
  return ['ARRIVED', 'IN_PROGRESS', 'PRE_CHECK'].includes(state);
};

const isOpenState = (state: GM.Booking.BookingDTO['state']) => {
  return ['IN_PROGRESS', 'PRE_CHECK'].includes(state);
};

/**
 * Занят ли стол физически: гость пришел и сидит за столом
 * @param reserveOrBookingItem
 */
export const isTableOccupied = (reserveOrBookingItem: {
  state: GM.Booking.BookingDTO['state'];
}) => {
  return isOccupiedState(reserveOrBookingItem.state);
};

/**
 * Открыт ли стол: гость пришел и стол открыт для него на кассе
 * @param reserveOrBookingItem
 */
export const isTableOpen = (reserveOrBookingItem: {
  state: GM.Booking.BookingDTO['state'];
  openedTableDate: string | null | undefined;
}) => {
  return isOpenState(reserveOrBookingItem.state) && !!reserveOrBookingItem.openedTableDate;
};

export const getTextWidth = (text: string, fontSize: number) => {
  const TEXT_WIDTH_RATIO = 0.6;

  return text.length * (fontSize * TEXT_WIDTH_RATIO);
};

export const useColoredSvgImage = (svgUrl: string, color: string) => {
  const [dataUrl, setDataUrl] = React.useState<string>();

  React.useEffect(() => {
    let alive = true;

    (async () => {
      const svgText = await (await fetch(svgUrl)).text();

      // Добавляем style="color:..."
      const coloredSvg = svgText.replace(/<svg\b([^>]*)>/i, (m, attrs) => {
        // если style уже есть — дописываем
        const hasStyle = /style="[^"]*"/i.test(attrs);
        if (hasStyle) {
          const patchedAttrs = attrs.replace(
            /style="([^"]*)"/i,
            (_m2, s) => `style="${s};color:${color}"`,
          );
          return `<svg${patchedAttrs}>`;
        }
        return `<svg${attrs} style="color:${color}">`;
      });

      const url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(coloredSvg);

      if (alive) {
        setDataUrl(url);
      }
    })();

    return () => {
      alive = false;
    };
  }, [svgUrl, color]);

  return useImage(dataUrl);
};
